import { render, staticRenderFns } from "./icon-radio-on.vue?vue&type=template&id=7834a8b6&"
import script from "./icon-radio-on.vue?vue&type=script&lang=js&"
export * from "./icon-radio-on.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports